import superagent from 'superagent';
let schemas = undefined;

export async function getSchemas() {
    if (!schemas) {
        try {
            const schemaRes = await superagent.get("/api/admin/auth/schemas").accept("json");
            console.log(schemaRes.body);
            let accessPolicies = schemaRes.body.AccessPolicies;
            let authenticationErrorCodes = schemaRes.body.AuthenticationErrorCodes;
            let bigscreenAccountStatus = schemaRes.body.BigscreenAccountStatus;
            let bigscreenAccountVersions = schemaRes.body.BigscreenAccountVersion;

            // slice an array - remove the first element
            accessPolicies = accessPolicies.slice(1);

            accessPolicies = accessPolicies.map(k => { return { "key": k, "value": k, "text": k } });
            bigscreenAccountStatus = Object.keys(bigscreenAccountStatus).map(k => { return { "key": k, "value": k, "text": bigscreenAccountStatus[k] } });
            bigscreenAccountVersions = Object.keys(bigscreenAccountVersions).map(k => { return { "key": k, "value": k, "text": `(${k}) ${bigscreenAccountVersions[k]}` } });
            schemas = { schemas: schemaRes.body, accessPolicies, authenticationErrorCodes, bigscreenAccountStatus, bigscreenAccountVersions };
        } catch (err) {
            console.error(err);
        }
    }

    console.log(schemas);

    return schemas;
}